import {BaseRequest, destroy, get, patch, post, PostRequest, put} from './jsonHttp';
import {API_URL} from '@/config';
import {refreshToken} from '@/domain/services/authService';

export const postRequest = async <ResponseType, RequestType = unknown>(request: Partial<PostRequest<RequestType>>): Promise<ResponseType> => {
  return post({
    ...request,
    baseUrl: API_URL ?? '',
    headers: await getHeaders({})
  });
};

export const getRequest = async <ResponseType, RequestType = undefined>(request: Partial<PostRequest<RequestType>>): Promise<ResponseType> => {
  return get({
    ...request,
    baseUrl: API_URL ?? '',
    headers: await getHeaders({})
  });
};

export const patchRequest = async <ResponseType, RequestType = unknown>(request: Partial<PostRequest<RequestType>>): Promise<ResponseType> => {
  return patch({
    ...request,
    baseUrl: API_URL ?? '',
    headers: await getHeaders({})
  });
};

export const putRequest = async <ResponseType, RequestType = unknown>(request: Partial<PostRequest<RequestType>>): Promise<ResponseType> => {
  return put({
    ...request,
    baseUrl: API_URL ?? '',
    headers: await getHeaders({})
  });
};

export const deleteRequest = async <DeleteRequest = unknown>(request: Partial<DeleteRequest>): Promise<void> => {
  return destroy({
    ...request,
    baseUrl: API_URL ?? '',
    headers: await getHeaders({})
  });
};

const getHeaders = async (request?: Partial<BaseRequest>): Promise<Record<string, string>> => {
  const {access} = await refreshToken();
  const headers = {...request?.headers};
  if (access) {
    headers['Authorization'] = `Bearer ${access}`;
  }
  return headers;
};
